import * as React from "react";
import { RtColumnsSettingsButton } from "src/components/ReactiveTable/components/RtColumnsSettings";
import { RtReloadButton } from "src/components/ReactiveTable/components/RtReloadButton";
import {
  RtCtrlColumnsSettings,
  RtCtrlLoad,
} from "src/components/ReactiveTable/ctrl";
import { AbstractFilters } from "src/components/ReactiveTable/RtTypes";

import * as styles from "./MdmTableSystemTools.module.less";

type PropsMdmTableSystemTools = {
  store: Pick<RtCtrlLoad<AbstractFilters>, "reload"> & RtCtrlColumnsSettings;
};

/** Системные кнопки таблицы: настройка колонок и обновление данных */
export const MdmTableSystemTools: React.FC<PropsMdmTableSystemTools> = ({
  store,
}) => (
  <div className={styles.box}>
    <RtColumnsSettingsButton store={store} />
    <RtReloadButton store={store} />
  </div>
);
